import { cn } from "@/lib/utils"
import { tabsListVariants, tabsTriggerVariants } from "@/components/ui/Tabs"

type Props = { label: string; tabs: { key: string; label: string }[]; active: string; onSelect: (key: string) => void }

// Same look as PlanTabs: the group's pages in the page title row.
export default function SegmentedTabs({ label, tabs, active, onSelect }: Props) {
  return (
    <nav aria-label={label} className={tabsListVariants({ variant: "segmented" })}>
      {tabs.map((t) => (
        <button
          key={t.key}
          type="button"
          onClick={() => onSelect(t.key)}
          data-state={t.key === active ? "active" : "inactive"}
          className={cn(tabsTriggerVariants({ variant: "segmented" }))}
        >
          {t.label}
        </button>
      ))}
    </nav>
  )
}
